import { forwardRef } from 'react';
import './Button.css';

/**
 * Кнопка сайту.
 *
 * variant:
 *   primary   — синя заливка, основна дія на екрані
 *   secondary — контур, другорядна дія (типове значення)
 *   accent    — жовта заливка з темним текстом, лише для акценту в синьому блоці
 *   link      — текстове посилання зі стрілкою, без рамки
 *   icon      — квадратна кнопка під один значок
 *
 * Ref прокидається до самого <button>: це потрібно для повернення фокуса після
 * закриття модальних вікон (ADR-0008).
 */
const Button = forwardRef(function Button(
  { className = '', buttonText, children, type, variant = 'secondary', ...props },
  ref
) {
  const classes = ['btn', `btn--${variant}`, className].filter(Boolean).join(' ');

  return (
    <button ref={ref} className={classes} type={type || 'button'} {...props}>
      {buttonText ?? children}
    </button>
  );
});

export default Button;
